var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunityBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2724_64208",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2724_64208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 17V10H7V17H5ZM11 17V10H13V17H11ZM2 8V6L12 1L22 6V8H2ZM6.475 6H17.525L12 3.25L6.475 6ZM2 21V19H14.05C14.0833 19.35 14.125 19.6875 14.175 20.0125C14.225 20.3375 14.3 20.6667 14.4 21H2ZM17 13.25V10H19V12.25L17 13.25ZM20 24C18.85 23.7167 17.8958 23.0542 17.1375 22.0125C16.3792 20.9708 16 19.8167 16 18.55V16L20 14L24 16V18.55C24 19.8167 23.6208 20.9708 22.8625 22.0125C22.1042 23.0542 21.15 23.7167 20 24ZM19.275 21L22.75 17.55L21.7 16.5L19.275 18.875L18.3 17.9L17.25 18.975L19.275 21Z",
    fill: "#707072"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunityBuilding);
export default __webpack_public_path__ + "static/media/Community Building.6bd336a8.svg";
export { ForwardRef as ReactComponent };